module.exports = __webpack_public_path__ + "img/icn_calendar.04b617c9.svg";